<template>
  <div id="app">
    <router-view/>
    
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang= 'scss'>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,body{
  width: 100vw;
  height: 100vh;
  background-color: #eee;
}
li{
  list-style: none;
}


</style>




// WEBPACK FOOTER //
// src/App.vue